import { CalmControls } from './control.js';
import { CalmMetadata } from './metadata.js';
export class CalmFlowTransition {
    constructor(originalJson, relationshipUniqueId, sequenceNumber, description, direction = 'source-to-destination') {
        this.originalJson = originalJson;
        this.relationshipUniqueId = relationshipUniqueId;
        this.sequenceNumber = sequenceNumber;
        this.description = description;
        this.direction = direction;
    }
    toCanonicalSchema() {
        return {
            'relationship-unique-id': this.relationshipUniqueId,
            'sequence-number': this.sequenceNumber,
            description: this.description,
            direction: this.direction
        };
    }
    static fromSchema(schema) {
        return new CalmFlowTransition(schema, schema['relationship-unique-id'], schema['sequence-number'], schema.description, schema.direction ?? 'source-to-destination');
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmFlow {
    constructor(originalJson, uniqueId, name, description, transitions = [], requirementUrl, controls, metadata) {
        this.originalJson = originalJson;
        this.uniqueId = uniqueId;
        this.name = name;
        this.description = description;
        this.transitions = transitions;
        this.requirementUrl = requirementUrl;
        this.controls = controls;
        this.metadata = metadata;
    }
    toCanonicalSchema() {
        return {
            'unique-id': this.uniqueId,
            name: this.name,
            description: this.description,
            'requirement-url': this.requirementUrl,
            transitions: this.transitions.map(transition => transition.toCanonicalSchema()),
            controls: this.controls ? this.controls.toCanonicalSchema() : undefined,
            metadata: this.metadata ? this.metadata.toCanonicalSchema() : undefined
        };
    }
    static fromSchema(schema) {
        const transitions = (schema.transitions ?? []).map(CalmFlowTransition.fromSchema);
        return new CalmFlow(schema, schema['unique-id'], schema.name, schema.description, transitions, schema['requirement-url'] ?? '', schema.controls ? CalmControls.fromSchema(schema.controls) : undefined, schema.metadata ? CalmMetadata.fromSchema(schema.metadata) : undefined);
    }
    toSchema() {
        return this.originalJson;
    }
}
//# sourceMappingURL=flow.js.map